export default __webpack_public_path__ + "static/media/6.fd57bd6e.png";